(function () {
  'use strict';
  if (customElements.get('vt-productgalerij')) return;

  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  function gedrag() { return rustig.matches ? 'auto' : 'smooth'; }

  class VtProductgalerij extends HTMLElement {
    connectedCallback() {
      if (this._klaar) return;
      this._klaar = true;

      this.spoor = this.querySelector('[data-gal-spoor]');
      this.vakken = Array.prototype.slice.call(this.querySelectorAll('[data-gal-vak]'));
      if (!this.spoor || this.vakken.length < 2) return;

      this.strook = this.querySelector('[data-gal-thumbs]');
      this.miniaturen = Array.prototype.slice.call(this.querySelectorAll('[data-gal-thumb]'));
      this.stippen = Array.prototype.slice.call(this.querySelectorAll('[data-gal-stip]'));
      this.vorige = this.querySelector('[data-gal-vorige]');
      this.volgende = this.querySelector('[data-gal-volgende]');
      this.stand = this.querySelector('[data-gal-stand]');
      this.nu = 0;

      var gal = this;

      this.miniaturen.forEach(function (m, i) {
        m.addEventListener('click', function (e) { e.preventDefault(); gal.ga(i); });
      });
      if (this.vorige) this.vorige.addEventListener('click', function () { gal.ga(gal.nu - 1); });
      if (this.volgende) this.volgende.addEventListener('click', function () { gal.ga(gal.nu + 1); });

      if ('IntersectionObserver' in window) {
        this.waarnemer = new IntersectionObserver(function (items) {
          items.forEach(function (item) {
            if (item.isIntersecting) gal.markeer(gal.vakken.indexOf(item.target));
          });
        }, { root: this.spoor, threshold: 0.6 });
        this.vakken.forEach(function (v) { gal.waarnemer.observe(v); });
      }

      var sectie = this.closest('.shopify-section');
      if (sectie) {
        this._opVariant = function (e) { gal.naarVariant(e); };
        sectie.addEventListener('shopify:product:select', this._opVariant);
        this._sectie = sectie;
      }

      this.markeer(0, true);
    }

    disconnectedCallback() {
      if (this.waarnemer) this.waarnemer.disconnect();
      if (this._sectie && this._opVariant) {
        this._sectie.removeEventListener('shopify:product:select', this._opVariant);
      }
      this._klaar = false;
    }

    ga(n) {
      var i = Math.max(0, Math.min(this.vakken.length - 1, n));
      this.spoor.scrollTo({
        left: this.vakken[i].offsetLeft - this.spoor.offsetLeft,
        behavior: gedrag()
      });
      this.markeer(i);
    }

    markeer(i, stil) {
      if (i < 0 || i >= this.vakken.length) return;
      var wasAnders = i !== this.nu;
      this.nu = i;

      this.miniaturen.forEach(function (m, n) {
        if (n === i) m.setAttribute('aria-current', 'true');
        else m.removeAttribute('aria-current');
      });
      this.stippen.forEach(function (s, n) { s.classList.toggle('is-aan', n === i); });
      if (this.vorige) this.vorige.disabled = i === 0;
      if (this.volgende) this.volgende.disabled = i === this.vakken.length - 1;

      if (this.stand && !stil && wasAnders) {
        this.stand.textContent = (this.stand.dataset.tekst || '')
          .replace('[n]', i + 1)
          .replace('[totaal]', this.vakken.length);
      }

      var actief = this.miniaturen[i];
      if (actief && this.strook && this.strook.scrollWidth > this.strook.clientWidth + 4) {
        this.strook.scrollTo({
          left: actief.offsetLeft - this.strook.offsetLeft
            - (this.strook.clientWidth - actief.offsetWidth) / 2,
          behavior: gedrag()
        });
      }
    }

    naarVariant(e) {
      var kaart = this.parentNode && this.parentNode.querySelector('[data-gal-map]');
      var vid = e.detail && e.detail.variantId;
      if (!kaart || !vid) return;
      var tabel;
      try { tabel = JSON.parse(kaart.textContent) || {}; } catch (fout) { return; }
      var id = tabel[String(vid)];
      if (!id) return;
      for (var n = 0; n < this.vakken.length; n++) {
        if (this.vakken[n].dataset.mediaId === id) { this.ga(n); return; }
      }
    }
  }

  customElements.define('vt-productgalerij', VtProductgalerij);
})();
